import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: process.env.NEXT_PUBLIC_THEME_PRIMARY_COLOR || '#47E1BC',
    },
    secondary: {
      main: '#fff',
    },
    text: {
      primary: '#fff',
    },
    divider: '#F4F6FF',
    error: {
      main: '#d0342c',
    },
    success: {
      main: '#4ECB71',
    },
  },
  typography: {
    allVariants: {
      fontFamily: 'Manrope !important',
    },
  },

  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'capitalize',
          borderRadius: 20,
        },
        sizeLarge: {
          fontSize: '1rem', // Example of a font size override for large buttons
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          background: '#2D3C4A',
          boxShadow: 'none',
        },
      },
    },
  },
});
